export default {
      id: "website-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#website",
      toString: function () {
        return this.url;
      }
    }